import {Expose} from "class-transformer";

export default class ModelTransferContact {
	@Expose({name: "phone"})
	private readonly _phone: string | null;

	@Expose({name: "email"})
	private readonly _email: string | null;

	constructor(phone: string, email: string) {
		this._phone = phone;
		this._email = email;
	}

	public get phone() {
		return this._phone;
	}

	public get email() {
		return this._email;
	}
}
